import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import http from './plugins/axios';
import userInfoHelper from 'common/userInfo';

Vue.use(Vuex);

//eslint-disable-next-line
const debug = process.env.NODE_ENV !== 'production';

const state = {
  userInfo: userInfoHelper.get(),
  userRights: userInfoHelper.getRights(),
  allSymbols: [],
  activePair: {}
};

const mutations = {
  setUserInfo(state, payload) {
    state.userInfo = payload;
    userInfoHelper.set(payload);
  },
  setUserRights(state, payload) {
    state.userRights = payload;
    userInfoHelper.setRights(payload);
  },
  setActivePair(state, pair) {
    state.activePair = pair;
  },
  setAllSymbols(state, payload) {
    state.allSymbols = payload;
  }
};

const actions = {
  login({ commit }, { username, password, code }) {
    return http
      .post({
        url: '/admin/login',
        data: {
          username,
          password,
          phoneCode: code
        }
      })
      .then(({ data }) => {
        let _data = Object.assign({}, data);
        if (_data.roleId === 10) {
          _data.roleId = 0;
          _data.isSupper = true;
        }
        commit('setUserInfo', _data);
        commit('setUserRights',_data.authList);
      });
  },
  logout() {
    return http
      .post({
        url: '/admin/logout'
      })
      .finally(() => {
        userInfoHelper.clear();
        userInfoHelper.clearRights();
        window.location.href = '/';
      });
  },
  //eslint-disable-next-line
  getPhoneCode({ commit }, loginName) {
    return new Promise(resolve => {
      http
        .get({
          url: '/admin/check/code',
          data: {
            loginName
          }
        })
        .then(({ data }) => {
          resolve(data);
        });
    });
  },
  getRightsDetail({ commit }) {
    return new Promise(resolve => {
      http
        .get({
          url: '/admin/userAuthInfo',
          data: {}
        })
        .then(({ data }) => {
          commit('setUserRights', data);
          resolve();
        });
    });
  },

  refreshAuthInfo ({commit}) {
    http.post({
      url : '/admin/auth/refresh',
    }).then( response => {
      commit('setUserInfo', response.data);
      commit('setUserRights',response.data.authList);
    })
  },
  getAllSymbols({commit}) {
    return new Promise(resolve => {
      http.get({
        url: '/admin/broker/contract/symbolList'
      }).then(res => {
        if (res.data) {
          const result = res.data.map(item => {
            return item.toUpperCase()
          })
          commit('setAllSymbols', result)
        }

      })
    })
  }
};

export default new Vuex.Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  state,
  mutations,
  actions
});
